// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2QMo-","name":"ConsentHeader_name__3SUQC","birthday":"ConsentHeader_birthday__2Yn6b","skeleton":"ConsentHeader_skeleton__iFqiG"};